import TeamViewPageContainer from './containers/TeamViewPageContainer'

export default TeamViewPageContainer
